import { saveAs } from "file-saver";
import { InfoMessage } from 'components';
import docSupDespDeclar from 'assets/documents/Υπεύθυνη Δήλωση Νόμιμου Εκπροσώπου_ΔΙΚ1.docx';

export const content = () =>
  [
    {
      label: 
      <div style={{display:'flex', marginRight:'5px'}}>
                <b>Υποβολή Υπεύθυνης Δήλωσης</b><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupDespDeclar, "Υπόδειγμα Υπεύθυνης Δήλωσης")}>εδώ</a>)</text>
      </div>,     
      fileCode: 'supDespDeclar',
      id: 'supDespDeclar',
      fileLimit: 10,
      multiple: true,
      required: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
    {
      label: <div style={{display:'flex', marginRight:'5px'}}>Πιστοποιητικό ή Υπεύθυνη Δήλωση
                <InfoMessage
                infoMessage={'Πιστοποιητικό ή βεβαίωση (από οικείο επιμελητήριο ή εμπορικό μητρώο ή άλλη αρμόδια αρχή) ή Υπεύθυνη Δήλωση'}
                overlayClassName={'multiline-info-message'}
                />
              </div>,
      fileCode: 'supCertForeignDocs',
      id: 'supCertForeignDocs',
      fileLimit: 10,
      multiple: true,
      required: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχεία'
    },
    {
      label: <div style={{display:'flex', marginRight:'5px'}}>Λοιπά Έγγραφα
                {/* <InfoMessage
                infoMessage={'Εκτύπωση στοιχείων IBAN.'}
                overlayClassName={'multiline-info-message'}
                /> */}
              </div>,
      fileCode: 'supOtherDocs',
      id: 'supOtherDocs',
      fileLimit: 10,
      multiple: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχεία'
    },
  ].filter(item => item);;
